import { ReactNode } from "react";
import Box from "@mui/material/Box";

/**
 * Page gutter, in px rather than a share of the viewport.
 *
 * A percentage gutter scaled the wrong way for this app: on the 1280px-wide machines it
 * runs on it took ~50px a side away from tables that already scroll sideways, while on a
 * large monitor the same percentage left a wide empty band. A fixed gutter gives every
 * screen the same breathing room and hands the rest of the width to the content.
 */
const GUTTER = 16;

function Container({ children }: { children: ReactNode }) {
  return (
    <Box sx={{ height: "100%", px: `${GUTTER}px` }}>{children}</Box>
  );
}

export default Container;
